var Search = {
	node:null,
	lateCall:null,

	init: function() {
		Search.node = $("<div id='search'></div>");
		Search.node.append(TPL.render("search-main", {"pointer_up": "on" + Events.pointer.up, "routing":PROJECT.settings['search/routing']}));
		$("#panels").append(Search.node);

		$("#search_box input").on("focus", Search.focusInput);
		$("#search_box input").on("blur", Search.blurInput);

		$("#search_box input").on("keyup", Search.typing);

		Search.button = $("<div id='search_icon'  class='bottombar'><img src='assets/search.png' width='32' height='32'></div><span id='search_tip' class='bottombar bbar_label'>" + TPL.lng("search.icon_title", "SZUKAJ") + "</span>");
		$("#overlay").append(Search.button);
		Search.button.on(Events.pointer.down, function(e) {
			Search.open();
			SpeechManager.speakTip("PLAYER.SEARCH", "TIPS");
		});
		SpeechManager.prepareTip("PLAYER.SEARCH", "TIPS");

		Tab.setGroup("search", "+");

//		Tab.add("search", Tab.simpleTabInput($("#words")), 1, {});
//		Tab.add("search", Tab.simpleTab($("#search_box .close a", 2, "focused", true)), 2, {});
		Tab.add("search", Tab.simpleTabInput($("#words"), 1), {});
		Tab.add("search", Tab.simpleTab($("#search_box .close a"), 2), {});

		Tab.groups['search'].disable();
	},

	focusInput: function() {
		$(".searchbar").addClass("focused");
	},

	blurInput: function() {
		$(".searchbar").removeClass("focused");
	},

	openAndFind: function(w) {
		$("#search_box input").val(w);
		Search.open();
	},

	open: function() {
		$("#search").show();
		//$("#search_box input").focus();
		$("#tsrchbtn").addClass("active");
		setTimeout(function() {$("#search_box input").focus();}, 100);
		Search.fillResults();		
		setTimeout(function() {$("#search").css("transform", "translate(0px, 0px)");}, 100);

		Tab.cancelStackAdd("search-sidebar", Search.close);
		Tab.groups['search'].enable();
	},

	close: function() {
		Tab.cancelStackRemove("search-sidebar");
		$("#search").css("transform", "translate(-500px, 0px)");
		$("#tsrchbtn").removeClass("active");
		setTimeout(function() {$("#search").hide();}, 1000);
		Tab.groups['search'].disable();
	},

	setStart: function(evt, target, plan, title) {
		//Search.close();
		//player.go(target, "0");
		//mapInfo.showMenu();


		if (Plan.target != null && Plan.target.planspot == target) {
			$("#search_result_box .row a").removeClass("ito");
			Plan.actionTarget();			
		}

		Search.startPlan = plan;

		$("#search_result_box .row a").removeClass("ifrom");
		$(evt.target).addClass("ifrom");

		Plan.setOriginById(target, title);

		Search.navMenu();
	},

	setEnd: function(evt, target, plan, title) {
		//mapInfo.showMenu();
		//Floors.load(plan);

		Search.endPlan = plan;
		if (Plan.target != null && Plan.origin.planspot == target) return;

		$("#search_result_box .row a").removeClass("ito");

		if (Plan.target != null && Plan.target.planspot == target) {
			Plan.actionTarget();			
		} else {
			$(evt.target).addClass("ito");

			Plan.setTargetById(target, title);
		}
//		mapInfo.showMenu();
//		console.log("set End");

		Search.navMenu();
	},

	fillResults: function() {
		$("#search_result_box").html("<div class='loader'><img src='assets/loading-bubbles.svg'></div>");

		if ($("#search_box input").val() == "") {
			$("#search_result_box").hide();
			$("#search_help_box").show();
		} else {
			$("#search_result_box").show();
			$("#search_help_box").hide();			
		}

		Search.navMenu();

		var scope = "city";

		if ($("#search_filter_all").prop("checked")) scope = "all";

		ssi("Search", "results", {"place" : player.ident, "scope" : scope, "words" : $("#search_box input").val()}, function(res) {

			$("#search_result_box").html("");

			var fields = {};

			//console.log(res);

			for(var i = 0; i < res.data.length; i ++) {
				fields.title = res.data[i].title;
				fields.id = res.data[i].id;
				fields.target = res.data[i].planspot;
				fields.plan = res.data[i].plan;
				fields.location = res.data[i].loc_name;
				fields.level = res.data[i].level;
				if (player.offline) fields.thumb = "data/thumb_" + res.data[i].id + ".jpg";
				else fields.thumb = res.data[i].thumb;
				fields.body = res.data[i].body;
				fields.extra = (res.data[i].content != undefined && res.data[i].content != "") ? res.data[i].content : "";
				fields.look_x = (res.data[i].look_x != null && res.data[i].look_x != "") ? res.data[i].look_x : "0";
				fields.look_y = (res.data[i].look_y != null && res.data[i].look_y != "") ? res.data[i].look_y : "0";

				fields.classfrom = "";
				fields.classto = "";

				if (Plan.origin != null && Plan.origin.planspot == fields.target) fields.classfrom = "ifrom";
				if (Plan.target != null && Plan.target.planspot == fields.target) fields.classto = "ito";

				if (player.ident == res.data[i].id) fields.current = 1;
				else fields.current = 0;
				fields.pointer_up = "on" + Events.pointer.up;
				fields.up = "on" + Events.pointer.up;
				fields.down = "on" + Events.pointer.down;
				fields.move = "on" + Events.pointer.move;
				if (fields.title == "") fields.title = "ID: " + res.data[i].id;
				fields.routing = PROJECT.settings['search/routing'];
				
				console.log(fields);

				$("#search_result_box").append(TPL.render("search-row", fields));
			}

			if (res.data.length == 0) {
				$("#search_result_box").html("Nie znaleziono żadnych pasujących miejsc.");
			} else {
				$("#search_result_box .row").each(function(no) {
					var self = $(this);
					var hh = self.find(".title").height();
					self.css("height", (hh + 30) + "px");
					self.find(".icons").css("top", (hh * 0.5 - 5) + "px")
				});
			}

			ScrollBar.update("#search_result_box");

		});

	},

	navMenu: function() {
		if ((Plan.origin != null && Plan.origin.planspot > 0) && (Plan.target != null && Plan.target.planspot > 0) && (Plan.origin.planspot != Plan.target.planspot)) {
			$("#search .buttons").show();
			$("#search_result_box").css("bottom", "57px");
		} else {
			$("#search .buttons").hide();
			$("#search_result_box").css("bottom", "0px");			
		}
	},

	typing: function(evt) {
		if (Search.lateCall != null) clearTimeout(Search.lateCall);

		if (evt.keyCode == 13) {
			Search.lateCall = null;
			Search.fillResults();
			$("#search_box input").blur();
		} else {
			Search.lateCall = setTimeout(Search.fillResults, 400);
		}

		if (evt.keyCode == 8) {
			evt.stopPropagation();
		}
	},

	// mouse handlers

	up: function(target, lx, ly) {
		if (Search.mcnt <= 1) {
			//Search.setStart(target);
			Search.close();
			if (lx != undefined && ly == undefined) player.go(target, lx);
			else if (lx != undefined && ly != undefined) player.go(target, lx+","+ly);
			else player.go(target, "0");			
		}
	},

	down: function() {
		Search.isDown = true;
		Search.mcnt = 0;
	},

	move: function() {
		if (Search.isDown) Search.mcnt ++;
	},

	goRoute: function() {
		Search.close();
		//mapInfo.hideMenu();

		Plan.goOrigin();
	},

	goMap: function() {
		Search.close();
		mapInfo.showWindow();
		Floors.load(Search.startPlan);
	}
}

PluginManager.add(Search);